import React from 'react'
import Header from '../component/Header'
import { motion } from "framer-motion";
import bg from '../rings.png'
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import Footer from '../component/Footer';
export default function Contact() {
    return (
        <>
            <Header/>
             <div className="relative h-[320px] md:h-[400px] flex items-center justify-center overflow-hidden">

                {/* Background Image */}
                <div
                    className="absolute inset-0 bg-cover bg-no-repeat bg-fixed"
                    style={{ backgroundImage: `url(${bg})` }}
                />

                {/* Dark Overlay */}
                <div className="absolute inset-0 bg-gradient-to-b from-[#172f47]/100 to-[#12253c]/70" />

                {/* Animated Glow */}
                <div className="absolute w-[400px] h-[400px] bg-blue-400/20 rounded-full blur-3xl animate-pulse top-[-120px] left-[-120px]" />
                <div className="absolute w-[300px] h-[300px] bg-orange-400/20 rounded-full blur-3xl animate-pulse bottom-[-100px] right-[-100px]" />

                {/* Content */}
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className="relative z-10 text-center px-6"
                >
                    {/* Title */}
                    <motion.h1
                        initial={{ opacity: 0, scale: 0.9 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ delay: 0.2 }}
                        className="text-3xl sm:text-4xl md:text-5xl font-bold text-white"
                    >
                        Contact <span className="text-[#00bd86]">US</span>
                    </motion.h1>

                    {/* Subtitle */}
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4 }}
                        className="mt-4 text-gray-200 text-sm sm:text-base max-w-xl mx-auto"
                    >
                       Let’s build the future of lending, together.

                      
                    </motion.p>
                </motion.div>
            </div>
              <section className="w-full py-20 px-4 sm:px-6 lg:px-8">
                <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-8">

                    {/* LEFT: FORM */}
                    <div className="lg:col-span-2 p-6 sm:p-8 ">

                        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
                            Get in Touch
                        </h2>
                        <p className="text-gray-600 mb-6">
                            Have questions about our financial solutions? Our advisors are ready to assist you.
                        </p>

                        <form className="grid grid-cols-1 sm:grid-cols-2 gap-4">

                            <input
                                type="text"
                                placeholder="Full Name"
                                className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-400"
                            />

                            <input
                                type="email"
                                placeholder="Email Address"
                                className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-400"
                            />

                            <input
                                type="text"
                                placeholder="Phone Number"
                                className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-400"
                            />

                            <input
                                type="text"
                                placeholder="Company Name"
                                className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-400"
                            />

                            <textarea
                                placeholder="How can we help you achieve your goals?"
                                rows={4}
                                className="sm:col-span-2 border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-400"
                            ></textarea>

                            <button
                                type="submit"
                                className="sm:col-span-2 bg-[#0fce84] hover:bg-orange-600 text-white py-3 rounded-lg font-medium transition"
                            >
                                Send Inquiry
                            </button>

                        </form>
                    </div>

                    {/* RIGHT: CONTACT CARDS */}
                    <div className="flex flex-col gap-6">

                        {/* Call Us */}
                        <div className="bg-white p-5 rounded-xl shadow flex gap-4 items-start">
                            <div className="bg-[#0fce84]/30 p-3 rounded-lg">
                                <LocalPhoneIcon className="w-5 h-5" />
                            </div>
                            <div>
                                <h3 className="font-semibold  text-lg">Call Us</h3>

                                <p className="text-gray-400 text-xs">
                                    Mon–Sat: 10:00 AM – 6:00 PM
                                </p>
                                <p className="text-gray-600 text-xl font-semibold ms-text-primary pt-1">+91 8796121151</p>
                            </div>
                        </div>

                        {/* Email */}
                        <div className="bg-white p-5 rounded-xl shadow flex gap-4 items-start">
                            <div className="bg-[#0fce84]/30 p-3 rounded-lg">
                                <EmailIcon className=" w-5 h-5" />
                            </div>
                            <div>
                                <h3 className="font-semibold text-gray-900">Email Us</h3>
                                <p className="text-gray-600 text-sm">
                                    For detailed queries and documentation.
                                </p>
                                <p className="text-gray-600 text-xl font-semibold ms-text-primary pt-1">
                                    info@lnvstech.com
                                </p>
                            </div>
                        </div>

                        {/* Priority Support */}
                        <div className="bg-[#072c4c] text-white p-6 rounded-xl shadow">
                            <h3 className="font-semibold mb-2">Priority Support</h3>
                            <p className="text-sm text-gray-300 mb-3 leading-7">
                                Dedicated 24/7 line for Platinum and Institutional clients.
                            </p>
                            <button className="text-[#0fce84] font-medium hover:underline">
                                Access Portal →
                            </button>
                        </div>

                    </div>
                </div>

                {/* LOCATIONS */}
                <div className="max-w-7xl mx-auto mt-12">


                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

                        <div>
                            <h3 className="text-2xl font-semibold mb-4 text-gray-900">
                                Our Locations
                            </h3>
                            <p>Visit us at our regional offices or registered headquarters for in- person consultations.</p>
                        </div>

                        <div className="bg-white p-5 rounded-lg shadow border-l-4 border-blue-500">
                            <p className="text-base opacity-50 font-semibold mb-1">
                                REGISTERED ADDRESS
                            </p>
                            <p className="text-gray-700 text-base pt-4">
                              15<sup>th</sup> floor Best Sky Tower Netaji Subhash Place Pitampura Delhi 110034
                            </p>
                        </div>

                        <div className="bg-white p-5 rounded-xl shadow border-l-4 border-green-500">
                            <p className="text-base opacity-50 font-semibold mb-1">
                               CIN No.
                            </p>
                            <p className="text-gray-700 text-lg pt-4 font-extrabold">
                                U62099DC2026PTC470406
                            </p>
                        </div>

                    </div>
                </div>
            </section>
            <Footer/>
        </>
    )
}
